import { useState, useCallback } from "react"

export const useFamiliesIds = () => {
  const [value, setValue] = useState([])

  const setCurrentValue = useCallback(familiesIds => setValue(familiesIds), [])

  return { value, setCurrentValue }
}
